import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NgxPubSubService } from '@pscoped/ngx-pub-sub';

@Injectable({
  providedIn: 'root'
})
export class PublicService {
  // baseUrl = "https://staging.habitatmarket.io/";
  // apiUrl = "https://staging.co2.expert/backend/api";
  // apiImageUrl = "https://staging.co2.expert/backend/api/get-image?path="; 

  // baseUrl = "http://127.0.0.1:4200/";
  // apiUrl = "http://127.0.0.1:8001/api";
  // apiImageUrl = "http://127.0.0.1:8001/api/get-image?path=";  

  baseUrl = "https://projects.green.earth/";
  apiUrl = "https://projects.green.earth/backend/api";
  apiImageUrl = "https://projects.green.earth/backend/api/get-image?path=";

  aranyaniApi = "https://ai.biodiversity.space/api";

  organizationPermission = { VIEW_ORGANIZATION:1,MANAGE_ORGANIZATION_ACCOUNT:2,CAN_BUY_HABITAT:3,FULL_ACCESS:4 };

  mapboxKey = "pk.eyJ1IjoiZGV2c3RhdGl4IiwiYSI6ImNrb3kwajV2ejBkaDIyb21zdm1lZzZvc2gifQ.mX7_k8dkysYZVLiU5GmYwQ"
  isLoggedIn = false;
  token:any;
  static userRoles = {INDIVIDUAL : "user", PROJECT_DEVELOPER:"project_owner", PROJECT_ADMIN : "project_admin", PROJECT_MANAGER : "project_manager", COLLEAGUE : "colleague"};

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'Access-Control-Allow-Origin':'*'
    })
  };


  constructor(private http: HttpClient, private router : Router,
    private pubsub : NgxPubSubService) {

  }

  getToken(){
    return {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization' : 'Bearer '+localStorage.getItem('token'),
        'Access-Control-Allow-Origin':'*'
      })
    };
  }

  getTokenForMultipart(){
    return {
      headers: new HttpHeaders({
        'Authorization' : 'Bearer '+localStorage.getItem('token'),
        'Access-Control-Allow-Origin':'*'
      })
    };
  }

  getMultipartToken(){
    return {
      headers: new HttpHeaders({
        /* 'Content-Type':  'multipart/form-data', */
        'Authorization' : 'Bearer '+localStorage.getItem('token'),
        'Access-Control-Allow-Origin':'*'
      })
    };
  }

  // getAranyaniToken(){
  //   return {
  //     headers: new HttpHeaders({
  //       'Accept': '*/*',
  //       'Content-Type': 'application/json',
  //       'Authorization': localStorage.getItem('token')
  //     })
  //   };
  // }
  getAranyaniToken(){
    return {
      headers: new HttpHeaders({
        'Accept': '*/*',
        'Content-Type': 'application/json',
        'Authorization': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2M2Y2MTVhNTAzYWIyZjk1M2IzZTA2OWIiLCJlbWFpbCI6ImRhdmlkLmtpcmFyaXRAZ3JlZW4uZWFydGgifQ.kQWohn4TcLyXvII5iVaaan8tCduxnjhuaRC41TnNNvA'
      })
    };
  }

  isTokenExpired(){
    if(localStorage.getItem('token')){
      let tokenDetails:any = atob(localStorage.getItem('token').split('.')[1]);
      tokenDetails = JSON.parse(tokenDetails);
      let tokenExpTime = new Date(tokenDetails.exp*1000).getTime();
      let currentTime = new Date().getTime();
      return (tokenExpTime > (currentTime+(60*1000)));
    }
    return false;
  }

  getCountries(){
    return this.http.get(this.apiUrl+"/countries?limit=all", this.httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getStates(countryId){
    return this.http.get(this.apiUrl+"/states/"+countryId+"?limit=all", this.httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getCities(stateId){
    return this.http.get(this.apiUrl+"/cities/"+stateId+"?limit=all", this.httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getCountryList(){
    return ["Afghanistan","Albania","Algeria","Andorra","Angola","Anguilla","Antigua & Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia & Herzegovina","Botswana","Brazil","British Virgin Islands","Brunei","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Cape Verde","Cayman Islands","Chad","Chile","China","Colombia","Congo","Cook Islands","Costa Rica","Cote D Ivoire","Croatia","Cruise Ship","Cuba","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Estonia","Ethiopia","Falkland Islands","Faroe Islands","Fiji","Finland","France","French Polynesia","French West Indies","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guam","Guatemala","Guernsey","Guinea","Guinea Bissau","Guyana","Haiti","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kuwait","Kyrgyz Republic","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macau","Macedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Mauritania","Mauritius","Mexico","Moldova","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Namibia","Nepal","Netherlands","Netherlands Antilles","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Norway","Oman","Pakistan","Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Puerto Rico","Qatar","Reunion","Romania","Russia","Rwanda","Saint Pierre & Miquelon","Samoa","San Marino","Satellite","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","South Africa","South Korea","Spain","Sri Lanka","St Kitts & Nevis","St Lucia","St Vincent","St. Lucia","Sudan","Suriname","Swaziland","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand","Timor L'Este","Togo","Tonga","Trinidad & Tobago","Tunisia","Turkey","Turkmenistan","Turks & Caicos","Uganda","Ukraine","United Arab Emirates","United Kingdom","Uruguay","Uzbekistan","Venezuela","Vietnam","Virgin Islands (US)","Yemen","Zambia","Zimbabwe"];
  }

  getOrganizationTypes(){
    return ["Academic Institution","Community","Company","Foundation"];;
  }

  getBusinessTypes(){
    return this.http.get(this.apiUrl+"/organizationtypes", this.httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getImages(url){
    return this.http.get(url, this.httpOptions)
    .pipe(
      catchError(this.handleError.bind(this))
    );
  }

  getActivities(search?){
    let params = this.getUrlParams(search);
    return this.http.get(this.apiUrl+"/project-activities"+params, this.httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getStatus(){
    return ["Active","In preperation","Completed"];
  }

  getCategories(){
    return  [
      {"name":"Administrative","subcategory":[{"name":"City","value":"City"},{"name":"Community Area","value":"Community Area"} ]},
      {"name":"Land Use","subcategory":[{"name":"Agriculture","value":"Agriculture"},{"name":"Agroforest","value":"Agroforest"} ]}
    ];
  }

  getPostCategories(){
    return ["Activity","Announcement","Fauna Observation","Flora Observation","Alert","Sponsoring"];
  }

  getUserTypes(){
    return this.http.get(this.apiUrl+"/user-roles", this.httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getBusinessType(){
    return this.http.get(this.apiUrl+"/organizationtypes", this.httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  login(user) {
    return this.http.post(this.apiUrl+"/login", user, this.getToken())
    .pipe(
      catchError(this.handleError.bind(this))
    );
  }

  forgotPassword(data) {
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+"/forgot-password", data, this.httpOptions).toPromise().then(response => {
        resolve(response);
      }).catch( err => {
        reject(err);
      })
    })
  }

  resetPassword(data) {
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+"/reset-password", data, this.httpOptions).toPromise().then(response => {
        resolve(response);
      }).catch( err => {
        reject(err);
      })
    })
  }

  customLogin(user) {
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+"/newlogin", user, this.httpOptions).toPromise().then(response => {
        resolve(response);
      }).catch( err => {
        reject(err);
      })
    })
  }

  verifyEmail(data) {
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+"/verify-user", data, this.httpOptions).toPromise().then(response => {
        resolve(response);
      }).catch( err => {
        reject(err);
      })
    })
  }

  register(data) {
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+"/register", data, this.httpOptions).toPromise().then(response => {
        resolve(response);
      }).catch( err => {
        reject(err);
      })
    })
  }

  customRegister(data) {
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+"/newregister", data, this.httpOptions).toPromise().then(response => {
        resolve(response);
      }).catch( err => {
        reject(err);
      })
    })
  }

  customRegister2(data) {
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+"/set-role", data, this.getToken()).toPromise().then(response => {
        resolve(response);
      }).catch( err => {
        reject(err);
      })
    })
  }

  getUserInfo(): Observable<any> {
    return this.http.get(this.apiUrl+"/user-info", this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  updateUserProfile(uid, data){
    return this.http.post(this.apiUrl+"/update-profile/"+uid, data, this.getTokenForMultipart())
    .pipe(
      catchError(this.handleError.bind(this))
    );
  }

  updateUserProfilePhoto(data){
    return this.http.post(this.apiUrl+"/update-profile/"+data.uid, data, this.getToken())
    .pipe(
      catchError(this.handleError.bind(this))
    );
  }

  getDashboardDetail(){
    return this.http.get(this.apiUrl+"/dashboard", this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getMyInvitation(){
    return this.http.get(this.apiUrl+"/my-invitations", this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getProjects(offset,query=""): Observable<any> {
    return this.http.get(this.apiUrl+"/project/list?offset="+offset+query, this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getPublicProjects(currentPage, offset,query=""): Observable<any> {
    return this.http.get(this.apiUrl+"/public/project/list?current_page="+currentPage+"&offset="+offset+query, this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getFeaturedProject(): Observable<any> {
    return this.http.get(this.apiUrl+"/project/featured", this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getPublishedProjects(offset): Observable<any> {
    return this.http.get(this.apiUrl+"/projects?offset="+offset+"&limit=10", this.httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getProjectSites(projectId, offset): Observable<any> {
    return this.http.get(this.apiUrl+"/sites/"+projectId+"?offset="+offset, this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getSites(projectId, offset): Observable<any> {
    return this.http.get(this.apiUrl+"/project/site/get/"+projectId+"?offset="+offset, this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  profileSubmission(profileData): Observable<any> {
    return this.http.post(this.apiUrl+"/organization/create", profileData, this.getTokenForMultipart())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  corporateProfileSubmission(profileData): Observable<any> {
    return this.http.post(this.apiUrl+"/customer/create", profileData, this.getTokenForMultipart())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  profileUpdate(uid, profileData): Observable<any> {
    return this.http.post(this.apiUrl+"/organization/update/"+uid, profileData, this.getTokenForMultipart())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  corporateProfileUpdate(uid, profileData): Observable<any> {
    return this.http.post(this.apiUrl+"/customer/update/"+uid, profileData, this.getTokenForMultipart())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  memberProfileSubmission(uid, profileData): Observable<any> {
    return this.http.post(this.apiUrl+"/update-profile/"+uid, profileData, this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getProject(projectId): Observable<any> {
    return this.http.get(this.apiUrl+"/project/get/"+projectId, this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getProjectDetail(projectId): Observable<any> {
    return this.http.get(this.apiUrl+"/projects/"+projectId, this.httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  createProjectLandCoverDetails(landCoverDetails): Observable<any> {
    return this.http.post(this.aranyaniApi+"/create-project", landCoverDetails,  this.getAranyaniToken())
    .pipe(
      catchError(error => {
        console.error('An error occurred:', error);
        // Handle the error gracefully
        return throwError('Error occurred while creating project landcover details.');
      })
    );
  }

  getProjectByCustomId(_id): Observable<any> {
    return this.http.get(this.aranyaniApi+"/get-project-by-custom-id/"+_id, this.getAranyaniToken())
    .pipe(
      catchError(error => {
        console.error('An error occurred:', error);
        // Handle the error gracefully
        return throwError('Error occurred while fetching project landcover details.');
      })
    );
  }

  getProjectByYear(_id, year): Observable<any> {
    const headers = this.getAranyaniToken().headers;
    return this.http.get(`${this.aranyaniApi}/get-project-by-year/${_id}?year=${year}`, { headers: headers })
    .pipe(
      catchError((error: any) => {
        console.error('Error occurred while fetching project landcover details:', error);
        return throwError(error); 
      })
    );
  }

  getProjectLogs(projectId): Observable<any> {
    return this.http.get(this.apiUrl+"/latest-updates?type=all&project_id="+projectId, this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  saveProject(projectDetail): Observable<any> {
    return this.http.post(this.apiUrl+"/project/create-with-image", projectDetail, this.getTokenForMultipart())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  checkIntersection(new_geojson): Observable<any> {
    return this.http.post(this.apiUrl+"/project/check-geojson-intersection", new_geojson, this.getTokenForMultipart())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }
  
  getNominatimOpenStreetLocation(coordinates) {
    const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${coordinates[1]}&lon=${coordinates[0]}`;

    return this.http.get(url, this.httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getCountryByName(countryName) {
    return this.http.get(this.apiUrl+"/get-country-by-name?name="+countryName, this.httpOptions);
  }

  getStateByName(stateName, country) {
    return this.http.get(this.apiUrl+"/get-state-by-name?name="+stateName+"&country="+country, this.httpOptions);
  }

  updateProject(id, projectDetail): Observable<any> {
    return this.http.post(this.apiUrl+"/project/update/"+id, projectDetail, this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  updateProjectGallery(id, formData): Observable<any> {
    return this.http.post(this.apiUrl+"/project/gallery/create/"+id, formData, this.getMultipartToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  deleteProjectGallery(id): Observable<any> {
    return this.http.get(this.apiUrl+"/project/gallery/delete/"+id, this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  uploadDocument(id, formData): Observable<any> {
    return this.http.post(this.apiUrl+"/project/documents/create/"+id, formData, this.getMultipartToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  sendInvite(data){
    return this.http.post(this.apiUrl+"/project/project-member/invite", data, this.getToken())
    .pipe(
      catchError(this.handleError.bind(this))
      );
  }

  sendCustomerInvite(data){
    return this.http.post(this.apiUrl+"/customer/invite", data, this.getToken())
    .pipe(
      catchError(this.handleError.bind(this))
      );
  }

  revokeCustomerInvite(data){
    return this.http.post(this.apiUrl+"/customer/revoke", data, this.getToken())
    .pipe(
      catchError(this.handleError.bind(this))
      );
  }

  getInvitedOrJoinedMember(data){
    let req = this.getToken();
    req['params'] = data;
    return this.http.get(this.apiUrl+"/customer/members", req)
    .pipe(
      catchError(this.handleError.bind(this))
      );
  }

  changePermissionForJoinedMember(data){
    return this.http.post(this.apiUrl+"/customer/members/permission", data, this.getToken())
    .pipe(
      catchError(this.handleError.bind(this))
      );
  }

  saveSite(siteDetail): Observable<any> {
    return this.http.post(this.apiUrl+"/project/site/create", siteDetail, this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  updateSite(siteDetail): Observable<any> {
    return this.http.post(this.apiUrl+"/project/site/update/"+siteDetail.site_id, siteDetail, this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getPosts(data): Observable<any> {
    data["status"] = "PUBLISHED";
    return this.http.get(this.apiUrl+"/posts", { "headers": this.getToken().headers, "params": data})
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getPost(id): Observable<any> {
    return this.http.get(this.apiUrl+"/posts/"+id, { "headers": this.getToken().headers })
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getProjectPosts(projectId, offset, limit): Observable<any> {
    return this.http.get(this.apiUrl+"/project/post/get/"+projectId+"?offset="+offset+"&limit="+limit, this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  savePost(postDetail): Observable<any> {
    return this.http.post(this.apiUrl+"/project/post/create", postDetail, this.getTokenForMultipart())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  updatePost(postDetail): Observable<any> {
    return this.http.post(this.apiUrl+"/project/post/update/"+postDetail.post_id, postDetail, this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  deletePost(postDetail): Observable<any> {
    return this.http.get(this.apiUrl+"/project/post/delete/"+postDetail.post_id, this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  deleteSite(siteDetail): Observable<any> {
    return this.http.get(this.apiUrl+"/project/site/delete/"+siteDetail.site_id, this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getOrganization(organizationId): Observable<any> {
    return this.http.get(this.apiUrl+"/organization/get", this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  updateOrganization(uid, organizationData): Observable<any> {
    return this.http.post(this.apiUrl+"/organization/update/"+uid, organizationData, this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  updateProfileImage(uid, profileData): Observable<any> {
    return this.http.post(this.apiUrl+"/update-profile/"+uid, profileData, this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  acceptInvitation(uid): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(this.apiUrl+"/accept-corporate-invite/"+uid).toPromise().then(response => {
        resolve(response);
      }).catch( err => {
        reject(err);
      })
    })
  }

  /* saveBlocks(data): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+"/checkout", data, this.getToken()).toPromise().then(response => {
        resolve(response);
      }).catch( err => {
        reject(err);
      })
    })
  } */

  saveBlocks(data){
    return this.http.post(this.apiUrl+"/checkout", data, this.getToken())
    .pipe(
      catchError(this.handleError.bind(this))
    );
  }

  makeCharge(data): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+"/charge", data, this.getToken()).toPromise().then(response => {
        resolve(response);
      }).catch( err => {
        reject(err);
      })
    })
  }

  toggleAutoRenew(transactionId: number, status: boolean): Observable<any> {
    return this.http.post(`${this.apiUrl}/auto-renew-transaction`, {
      transaction_id: transactionId,
      auto_renew: status,
    }, this.getToken());
  }

  getTransactions(params): Observable<any> {
    let _data = this.getToken();
    _data['params'] = params;
    return this.http.get(this.apiUrl+"/customer/get-transactions", _data)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getLandingStatistics(): Observable<any> {
    return this.http.get(this.apiUrl+"/landing-statistics", this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getUserOwnedProjectBlocks(projectId): Observable<any> {
    return this.http.get(this.apiUrl+"/get-transactions?site_id="+projectId, this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getSpeciesCategorylist(){
    return this.http.get(this.apiUrl+"/species/category/list", this.httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getSpeciesTypelist(category){
    return this.http.get(this.apiUrl+"/species/type/list?categoryId="+category, this.httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getSpeciesNameList(typeId){
    return this.http.get(this.apiUrl+"/species/name/list?subcategoryId="+typeId, this.httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }
  
  getSdgList(){
    return this.http.get(this.apiUrl+"/sdg-list")
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getProjectLeaders(search?){
    return this.http.get(this.apiUrl+"/leaders?"+search, this.httpOptions)
  }

  getInvestmentProject(): Observable<any> {
    return this.http.get(this.apiUrl+"/project/user/invest", this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getFeaturedProjects(){
    return this.http.get(this.apiUrl+"/feature-projects", this.httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getProjectOptionList(){
    return this.http.get(this.apiUrl+"/project/option/list", this.httpOptions)
  }

  getMasterCategory(){
    return this.http.get(this.apiUrl+"/category/group", this.httpOptions)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getFilterOptions(): Promise<any> {
    return new Promise((resolve, reject) => {
      if(localStorage.getItem('filterOption')){
        resolve(JSON.parse(localStorage.getItem('filterOption')));
      }else{
        this.http.get(this.apiUrl+"/category/group").toPromise().then((response:any) => {
          let filter_option_data = [{
            filter_type:"Intervention Type",
            filter_key : "intervention",
            filter_selected_value : "",
            filter_options:[],
          },
          {
            filter_type:"Location",
            filter_key : "location",
            filter_selected_value : "",
            filter_options:[],
          },
          {
            filter_type:"Biome",
            filter_key : "biome",
            filter_selected_value : "",
            filter_options:[],
          },
          {
            filter_type:"Species",
            filter_key : "species",
            filter_selected_value : "",
            filter_options:[]
          }];
          response.data.intervention.forEach(intervention => {
            filter_option_data[0].filter_options.push(intervention.title);
          });
          response.data.location.forEach(location => {
            filter_option_data[1].filter_options.push(location.title);
          });
          response.data.biome.forEach(biome => {
            filter_option_data[2].filter_options.push(biome.title);
          });
          response.data.species.forEach(species => {
            filter_option_data[3].filter_options.push(species.title);
          });
          localStorage.setItem('filterOption',JSON.stringify(filter_option_data));
          resolve(filter_option_data);
        }).catch( err => {
          reject(err);
        })
      }
    })
  }

  getUrlParams(search){
    let params = "?1=1";
    if(search){
      Object.keys(search).forEach(e => {
        params += "&"+e+"="+search[e];
      });
    }
    return params;
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
      this.pubsub.publishEvent('logout');
    } else {
      if(error.status == 500){
        console.log(error);
      } else if(error.status == 401){
        this.pubsub.publishEvent('logout');
      } else if(error.status == 400){
        console.log(error);
        return throwError(error.error);
      }
/*       if(error.error.status == "Token is Expired"){
        this.pubsub.publishEvent('logout');
      }
      else if(error.error.error == "User is not invited Yet"){
        return throwError({"status":"not_invited", "message":"You are not invited yet"});
      }
      else if(error.error.error == "User is not registered Yet"){
        return throwError({"status":"not_registered", "message":"You are not registered yet"});
      } */
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // Return an observable with a user-facing error message.
    return throwError(
      'Something bad happened; please try again later.');
  }

  //============================= general code ==============================

  getProjectLocation(project){
    let location = [];
    
    if(project.country && project.country.name){
      location.push(project.country.name);
    }else if(project.country_name && project.country_name.name){
      location.push(project.country_name.name);
    }

    if(project.province && project.province.name){
      location.push(project.province.name);
    }else if(project.province_name && project.province_name.name){
      location.push(project.province_name.name);
    }
   
    return location.join(",");
  }

  getProjectImage(project){
    if(project.header_image){
      return this.apiImageUrl+project.header_image
    }
    return "https://media.istockphoto.com/photos/man-sowing-the-land-at-a-farm-picture-id668076810?k=20&m=668076810&s=612x612&w=0&h=5q9Iqqa0nYhn-MJL80jETxeikjMLBR6PBQhEDUGD5WI=";
  }

  getProjectSpeciesImage(allSpecies)
  {
    if(allSpecies && allSpecies.length>0){
      return this.apiImageUrl+allSpecies[0].species_image
    }
    return 'assets/newimages/barry.png';
  }

  getBlogImage(blog){
    if(blog.header_image){
      return this.apiImageUrl+blog.header_image
    }
    return "https://media.istockphoto.com/photos/man-sowing-the-land-at-a-farm-picture-id668076810?k=20&m=668076810&s=612x612&w=0&h=5q9Iqqa0nYhn-MJL80jETxeikjMLBR6PBQhEDUGD5WI=";
  }

  getProjectGallery(gallery){
    gallery.forEach(g => {
      g.image = this.apiImageUrl+g.image;
    });
    return gallery;
  }

  getCountryFlagImage(country){
    if(country && country.flag){
      return this.apiImageUrl+country.flag
    }
    return 'https://m.media-amazon.com/images/I/31hUa4vD7aL._AC_SX466_.jpg';
  }

  getUserImage(avatar){
    if(avatar){
      return this.apiImageUrl+avatar
    }
    return this.apiImageUrl+'profileimg.png';
  }

  getBoughtPercentage(project){
    // console.log("project.total_area",project.total_area);
    if(project.total_area){
      return Math.round(100*(this.getTotalBought(project)/project.total_area));
    }
    return 0;
  }

  //meter square to hactare
  getTotalBought(project){
    //console.log("project.total_tiles_bought", project.total_tiles_bought);
    if(project.total_tiles_bought){
      return project.total_tiles_bought;
    }
    return 0;
  }

  getProjectActivities(project){
    this.getActivities({ids:project.activities_ids}).subscribe(response => {
      project.projectTags = response.activities.map(function(value,index) { return value['name']; });
    });
  }

  getActivityName(activities){
    return activities.map(function(value,index) { return value['name']; })
  }

  getUserNotification(){
    return this.http.get(this.apiUrl+"/notifications", this.getToken())
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getMyOwnerOrganization(params){
    let data = this.getToken();
    data['params'] = params;
    return this.http.get(this.apiUrl+"/user/getMyOwnerOrganization", data)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  getFormattedDate(date, prefomattedDate, hideYear = false) {
    const MONTH_NAMES = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const day = date.getDate();
    const month = MONTH_NAMES[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours();
    let minutes = date.getMinutes();
  
    if (minutes < 10) {
      // Adding leading zero to minutes
      minutes = `0${ minutes }`;
    }
  
    if (prefomattedDate) {
      // Today at 10:20
      // Yesterday at 10:20
      return `${ prefomattedDate } at ${ hours }:${ minutes }`;
    }
  
    if (hideYear) {
      // 10. January at 10:20
      return `${ day }. ${ month } at ${ hours }:${ minutes }`;
    }
  
    // 10. January 2017. at 10:20
    return `${ day }. ${ month } ${ year }. at ${ hours }:${ minutes }`;
  }
  
  
  // --- Main function
  timeAgo(dateParam) {
    if (!dateParam) {
      return null;
    }
  
    const date = typeof dateParam === 'object' ? dateParam : new Date(dateParam);
    const DAY_IN_MS = 86400000; // 24 * 60 * 60 * 1000
    const today = new Date();
    const yesterday = new Date(today.getTime() - DAY_IN_MS);
    const seconds = Math.round((today.getTime() - date.getTime()) / 1000);
    const minutes = Math.round(seconds / 60);
    const isToday = today.toDateString() === date.toDateString();
    const isYesterday = yesterday.toDateString() === date.toDateString();
    const isThisYear = today.getFullYear() === date.getFullYear();
  
  
    if (seconds < 5) {
      return 'now';
    } else if (seconds < 60) {
      return `${ seconds } seconds ago`;
    } else if (seconds < 90) {
      return 'about a minute ago';
    } else if (minutes < 60) {
      return `${ minutes } minutes ago`;
    } else if (isToday) {
      return this.getFormattedDate(date, 'Today'); // Today at 10:20
    } else if (isYesterday) {
      return this.getFormattedDate(date, 'Yesterday'); // Yesterday at 10:20
    } else if (isThisYear) {
      return this.getFormattedDate(date, false, true); // 10. January at 10:20
    }
  
    return this.getFormattedDate(date, false, false); // 10. January 2017. at 10:20
  }


  contactNow(data) {
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+"/contact", data, this.httpOptions).toPromise().then(response => {
        resolve(response);
      }).catch( err => {
        reject(err);
      })
    })
  }

  checkPermission(accessCodes){
    if(!localStorage.getItem('organizationId')){
      return true;
    }

    let access = JSON.parse(localStorage.getItem('permission'));
    if(access){
      let exist = access.filter(x => { return accessCodes.includes(x.accesscode)});
      return (exist && exist.length>0);
    }
    return false;
  }

  hasEditProfilePermission(){
    return this.checkPermission([this.organizationPermission.MANAGE_ORGANIZATION_ACCOUNT,this.organizationPermission.FULL_ACCESS])
  }

  hasMemberOrTransactionViewPermission(){
    return this.checkPermission([this.organizationPermission.MANAGE_ORGANIZATION_ACCOUNT,this.organizationPermission.FULL_ACCESS])
  }

  hasViewCompanyPermission(){
    return this.checkPermission([this.organizationPermission.VIEW_ORGANIZATION,this.organizationPermission.MANAGE_ORGANIZATION_ACCOUNT,this.organizationPermission.FULL_ACCESS])
  }

  hasCanBuyHabitatPermission(){
    return this.checkPermission([this.organizationPermission.CAN_BUY_HABITAT,this.organizationPermission.FULL_ACCESS])
  }

}
